type AsyncFunction<T, A extends unknown[]> = (...args: A) => Promise<T>;

type AsyncError = Error & { errorCode: string };

export const asyncAttempt = async <T, A extends unknown[]>(
  fn: AsyncFunction<T, A>,
  ...args: A
): Promise<[AsyncError] | [null, T]> => {
  let error: AsyncError | null = null;
  let result: T | undefined;

  try {
    result = await fn(...args);
  } catch (e) {
    error = e as AsyncError;
    return [error];
  }

  return [null, result];
};
